module.exports = __webpack_public_path__ + "img/rocket.17fef982.png";